import { t } from '@lingui/macro';

import applePayImage from 'assets/apple-pay.png';
import googlePayImage from 'assets/google-pay.png';
import { useBannerContext } from './BannerProvider';

const Banner = ({ image, text }) => (
  <div className="flex items-center p-2">
    <img className="h-8 md:h-10" src={image} alt="Apple Pay" />
    <p className="ml-4 md:ml-8 md:text-lg text-white">{text}</p>
  </div>
);

export const PaymentMethodsBanner = () => {
  const { paymentRequestMethods } = useBannerContext();

  return paymentRequestMethods ? (
    <div className="flex justify-center bg-black">
      {paymentRequestMethods?.applePay && (
        <Banner image={applePayImage} text={t`Now Accepting Apple Pay`} />
      )}
      {paymentRequestMethods?.googlePay && (
        <Banner image={googlePayImage} text={t`Now Accepting Google Pay`} />
      )}
    </div>
  ) : null;
};
